import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SiteStore } from '@core/site/site.store';

export const subscriptionModuleGuard = () => {
  const site = inject(SiteStore);
  const router = inject(Router);
  if (!site.showSubscriptionModule()) {
    return router.createUrlTree(['/']);
  }
  return true;
};
